import FormControl from "@mui/material/FormControl";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import OutlinedInput from "@mui/material/OutlinedInput";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import Visibility from "@mui/icons-material/Visibility";
import { FORM_CONTROL_SX } from "../constants";
import { FieldError } from "./FieldError";

export type PasswordFieldProps = {
  label: string;
  value: string;
  onChange: (value: string) => void;
  disabled: boolean;
  showPassword: boolean;
  onToggleVisibility: () => void;
  error: boolean;
  color: "error" | "success";
  helperText?: string;
  placeholder: string;
};

export function PasswordField({
  label,
  value,
  onChange,
  disabled,
  showPassword,
  onToggleVisibility,
  error,
  color,
  helperText,
  placeholder,
}: PasswordFieldProps) {
  return (
    <FormControl sx={FORM_CONTROL_SX}>
      <label>
        {label}
        <span className="star-requied">*</span>
      </label>
      <OutlinedInput
        sx={{ width: "100%" }}
        required
        disabled={disabled}
        type={showPassword ? "password" : "text"}
        error={error}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        color={color}
        placeholder={placeholder}
        endAdornment={
          <InputAdornment position="end">
            <IconButton
              sx={{ fontSize: 5 }}
              aria-label="toggle password visibility"
              onClick={onToggleVisibility}
              onMouseDown={(e) => e.preventDefault()}
              edge="end">
              {showPassword ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          </InputAdornment>
        }
      />
      {helperText && error && <FieldError>{helperText}</FieldError>}
    </FormControl>
  );
}
